import { breakpoints, css } from 'src/styles/theme';
import { rem } from 'polished';

export const StylesOVGB = css`
    .filters {
        color: ${({ theme }) => theme.colors.black2};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }
`;
